import { axiosInstance } from "..";

export const getCollaborators = async () => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("/users/collaborator")
      .then((res) => {
        if (res?.code === 200) {
          let data = res?.data?.map((user) => ({
            title: user?.name,
            id: user?._id,
            imageUrl: user?.image,
          }));
          resolve({
            success: true,
            data: data?.length ? data : [],
            message: res?.message,
          });
        } else {
          reject({ success: false, data: [], message: res?.message });
        }
      })
      .catch((err) => {
        reject({ success: false, data: [], message: err?.message });
      });
  });
};

export const getAdminInfo = async () => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("/singleton/JainGlory-INFO")
      .then((res) => {
        if (res?.code === 200) {
          resolve({
            success: true,
            data: res?.data?.data || {},
            message: res?.message,
          });
        } else {
          reject({ success: false, data: {}, message: res?.message });
        }
      })
      .catch((err) => {
        reject({ success: false, data: {}, message: err?.message });
      });
  });
};
